import React, { useEffect, useState } from 'react';
import { WhatsAppSvg } from '../assets/svg/WhatsAppSvg';
import { theme } from '../constants';

const FloatingWhatsAppButton: React.FC = () => {
    const [isBouncing, setIsBouncing] = useState(true);

    const handleClick = () => {
        window.open('https://wa.me/+251980303065', '_blank');
    };

    useEffect(() => {
        const interval = setInterval(() => {
            setIsBouncing((prev) => !prev);
        }, 2000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className='flex items-center'>
            <div
                style={{
                    position: 'fixed',
                    bottom: '30px',
                    right: '30px',
                    backgroundColor: theme.colors.pastelMint,
                    borderRadius: '50%',
                    padding: '8px',
                    cursor: 'pointer',
                    zIndex: 1000,
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.3)',
                    transform: isBouncing ? 'translateY(-10px)' : 'translateY(0)',
                    transition: 'transform 0.3s ease-in-out',
                }}
                onClick={handleClick}
            >
                <WhatsAppSvg />
            </div>
            <span
                style={{
                    zIndex: '50',
                    position: 'fixed',
                    bottom: '40px',
                    right: '90px', // Adjust as needed
                    color: 'black',
                    backgroundColor: 'white',
                    padding: '5px 10px',
                    borderRadius: '5px',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.3)',
                }}
            >
                👋 Can we assist you?
            </span>
        </div>
    );
};

export default FloatingWhatsAppButton;